import {
  Component,
  contentChild,
  input,
  linkedSignal,
  signal,
} from '@angular/core';
import { FormField } from '@angular/forms/signals';
import { coerceBoolean } from '../../cdk/utils';

export type Link = { text: string; url: string; target?: '_blank' | '_self' };

export type FormFieldControlLike = {
  disabled: () => boolean;
  required: () => boolean;
};

@Component({
  selector: 'tvd-form-field',
  templateUrl: './form-field.html',
  styleUrl: './form-field.scss',
  host: {
    class: 'block',
  },
})
export class TVDFormField {
  readonly link = input<Link>();

  readonly loading = input(false, { transform: coerceBoolean });

  readonly formField = contentChild(FormField);

  /** Optionally set by the projected form control*/
  readonly control = linkedSignal<FormFieldControlLike | null>(
    () => this.formField()?.state() || null,
  );
}
